export default __webpack_public_path__ + "images/logos/logo-documents.jpg?5f324e60de33db652e20d0144b24b1f3d575148d36ebb0de70ffd4527ae151b8";